import graphql__69d871ace97821709c68 from "./__generated__/PageSectionFilesList_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import LibraryFile from "../Library/LibraryFile";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";

const PageSectionFilesList = props => {
  const { title, iconClass, description, files, columnsRatio, columnsOrder, sidebar } =
    props.pageSection;

  const hasFiles = files.length > 0;

  // A files list without any file stays hidden, but its sidebar is filled independently
  // of the files, so it would be discarded along with it. It is rendered on its own to
  // avoid dropping content the administrator never asked to remove.
  if (!hasFiles && !sidebar?.hasSections) {
    return null;
  }

  return (
    <div className="container page-section page-section-files-list">
      <ContainerWithSidebar {...{ sidebar, columnsRatio, columnsOrder }}>
        {hasFiles && (
          <PageSectionBlockWithTitleAndDescription
            title={title}
            description={description}
            iconClassName={iconClass}
          >
            <ul className="pages-list list-unstyled boxes-list">
              {files.map(file => (
                <li key={file.id} className="box box-shadow">
                  <LibraryFile key={file.id} file={file} />
                </li>
              ))}
            </ul>
          </PageSectionBlockWithTitleAndDescription>
        )}
      </ContainerWithSidebar>
    </div>
  );
};

export default createFragmentContainer(PageSectionFilesList, {
  pageSection: graphql__69d871ace97821709c68
});
